module.exports = __webpack_public_path__ + "img/value-white.84f22697.svg";